var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMachinesIcon = function SvgMachinesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3AACC8",
    fillRule: "evenodd",
    clipPath: "url(#machines-icon_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.926 9 2.61 1.507-.915 1.586-1.695-.978-1.695.978-.915-1.586zm-6.916 3.993.916 1.586-1.695.978v1.957H10.4V14.5zm13.832 0 2.61 1.507v3.014h-1.831v-1.957l-1.695-.978zM10.4 22.486h1.831v1.957l1.695.978-.916 1.586L10.4 25.5zm19.053 0V25.5l-2.611 1.507-.916-1.586 1.695-.978v-1.957zm-12.137 7.007.915-1.586 1.695.978 1.695-.978.916 1.586L19.927 31zM19.926 13.186l5.901 3.407v6.814l-5.9 3.407-5.902-3.407v-6.814zm-4.07 4.465v4.698l4.07 2.35 4.07-2.35v-4.698l-4.07-2.35z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "machines-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8h24v24H8z"
  })))));
};
export { SvgMachinesIcon as ReactComponent };
export default __webpack_public_path__ + "2b75641b32652f586265006ed68a38ba.svg";